// Stub — reemplaza el módulo original de Lovable.
// Antes no hacía nada fuera de DEV — cualquier excepción no capturada en producción (ej. un
// grantXp que falla después de ya haber marcado un objetivo como completado) quedaba invisible
// para siempre, ni el staff ni nadie del equipo se enteraba (hallazgo de auditoría real). Por
// ahora esto solo deja rastro en la consola del navegador de quien esté mirando en ese momento
// — no hay todavía un servicio de reporte remoto configurado — pero es estrictamente mejor que
// el silencio total de antes, y deja el punto único de enganche para cuando se agregue uno.
import { monitor } from "./sentry";

export function reportLovableError(error: unknown, context?: Record<string, unknown>) {
  console.error("[CP Error]", error, context);
  // Además va a Sentry solo si hay DSN (si no, no hace nada). Nunca debe romper el reporte.
  try { monitor.capturar(error, context); } catch { /* sin efecto */ }
}
